module.exports = __webpack_public_path__ + "static/img/crs-spotlight-context-matters.a39b738.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/main/crs-spotlight-context-matters.png
// module id = cLlx
// module chunks = 0